module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_gal-f08299ce6363ceaafc5f2830e797a222.png";